import React from "react";
import "./whyus.css";
import clockimg from "../images/why_us/Vector.svg";
import peopleimg from "../images/why_us/crowd-people-group-public-svgrepo-com 1.svg";
import userimg from "../images/why_us/user-svgrepo-com 1.svg";
import budgetimg from "../images/why_us/cost-effective-productive-svgrepo-com 1.svg";
import oversea from "../images/why_us/earth-outline.svg";
import techimg from "../images/why_us/laptop-svgrepo-com.svg";
import panindimg from "../images/why_us/india-svgrepo-com.svg";
import whycardbg from "../images/whyus card bg.png";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function WhyUs() {
  const settings = {
    arrows: false,
    dots: true,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 2,
    autoplay: true,
    speed: 800,
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 920,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 620,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className="whyus_container container">
      <p className="container_heading">
        <span className="heading_first">Why</span> Us ?
      </p>

      {/* <p className="whyus_text">
        The Eventdex robust Online event management platform includes all the
        solutions event planners and project managers need. Now, one app can
        handle their events from start to finish.
      </p> */}

      {/* <div className="whyus_cards"> */}
      <Slider {...settings} className="whyus_cards">
        <div className="whyus_card">
          <img className="whyus_card_img" src={clockimg} />
          <p className="whyus_card_text">Quick and Responsive</p>
        </div>

        <div className="whyus_card">
          <img className="whyus_card_img" src={userimg} />
          <p className="whyus_card_text">Value Oriented</p>
        </div>

        <div className="whyus_card">
          <img className="whyus_card_img" src={budgetimg} />
          <p className="whyus_card_text">Budget Friendly </p>
        </div>

        <div className="whyus_card">
          <img className="whyus_card_img" src={peopleimg} />
          <p className="whyus_card_text">Strong Team</p>
        </div>

        <div className="whyus_card">
          <img
            style={{
              filter:
                "invert(77%) sepia(49%) saturate(0%) hue-rotate(137deg) brightness(109%) contrast(97%)",
            }}
            className="whyus_card_img"
            src={techimg}
          />
          <p className="whyus_card_text">Technology Driven</p>
        </div>

        <div className="whyus_card">
          <img
            style={{
              filter:
                "invert(77%) sepia(49%) saturate(0%) hue-rotate(137deg) brightness(109%) contrast(97%)",
            }}
            className="whyus_card_img"
            src={panindimg}
          />
          <p className="whyus_card_text">PAN India</p>
        </div>

        <div className="whyus_card">
          <img
            style={{
              filter:
                "invert(77%) sepia(49%) saturate(0%) hue-rotate(137deg) brightness(109%) contrast(97%)",
            }}
            className="whyus_card_img"
            src={oversea}
          />
          <p className="whyus_card_text">Work Overseas</p>
        </div>
      </Slider>
      {/* </div> */}
    </div>
  );
}

export default WhyUs;
